// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadCrossSells,
    LoadProducts,
    LoadRelatedProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";

const XLoadCrossSells: typeof LoadCrossSells = props => {
    const {
        parameter: { carouselType, productId },
    } = props;
    if (carouselType !== "crossSells") {
        return;
    }

    props.getProductCollectionParameter = {
        filter: "siteCrosssells",
        pageSize: 999,
        ...(productId ? { productId } : {}),
    };
};

const XLoadAlternativeProducts: typeof LoadRelatedProducts = props => {
    const {
        parameter: { carouselType, productId },
    } = props;
    if (carouselType !== "alternative" || !productId) {
        return;
    }

    props.getProductCollectionParameter = {
        productId,
        relationship: "alternative",
        pageSize: 999,
    };
};

const XLoadFeaturedProducts = (props: any) => {
    const {
        parameter: { carouselType, productNumbers },
    } = props;
    // Add product numbers incase we have featured carousel
    props.getProductCollectionParameter = {
        ...props.getProductCollectionParameter,
        ...(carouselType === "featuredProducts" && {
            productNumbers,
            pageSize: Math.max(16, productNumbers?.length || 0),
        }),
    };
};

const XLoadProducts: typeof LoadProducts = props => {
    if (!props.getProductCollectionParameter?.expand) {
        props.getProductCollectionParameter = {
            ...props.getProductCollectionParameter,
            expand: ["properties"],
        };
    } else {
        props.getProductCollectionParameter.expand.push("properties");
    }
};

replaceInChain(chain, LoadCrossSells, XLoadCrossSells);
addToChainBefore(chain, LoadRelatedProducts, XLoadAlternativeProducts);
addToChainBefore(chain, LoadRelatedProducts, XLoadFeaturedProducts);
addToChainBefore(chain, LoadProducts, XLoadProducts);
